export const routes = {
    home: "/",

    reglamento: "/reglamento",
    galeria: "galeria",
    preinscribirse: "/preinscribirse",
    formularioPreinscripcion: "/formulario-preinscripcion",
    participantes: "/participantes",
    resultados: "/resultados",   
    contribuidores: "/contribuidores",

    login: "/login",
    register: "/register",
    verifyEmail: "/verify-email",
    passwordForgot: "/password-forgot",
    passwordReset: "/password-reset",   
}